import React, { useEffect, useRef } from 'react';

import { SMART_HUB_2_PRODUCT } from 'features/order-tracker/pages/order-summary/components/MilestonesColumn/constants';
import { ExternalLink } from 'features/order-tracker/shared-components/ExternalLink';
import { AppointmentAnalyticService } from 'features/order-tracker/store/sagas/services/appointmentAnalyticsService';

import hybridConnectImg from 'assets/order-tracker/HybridConnect.png';
import {
  ANALYTICS_TYPE_APPOINTMENT,
  ANALYTICS_TYPE_DELIVERY,
  GET_ONLINE_LABEL,
  GET_ONLINE_SMART_HUB_2_URL,
  GET_ONLINE_SMART_HUB_3_URL,
  HC_IN_DELIVERY_DESCRIPTION,
  HC_IN_DELIVERY_TITLE,
  HC_IN_OPENREACH_APPT_DESCRIPTION,
  HC_IN_OPENREACH_APPT_TITLE,
} from './constants';

import styles from './styles.module.scss';

export const HybridConnectInfo: React.FC<sharedComponents.HybridConnectInfo> = ({
  isDeliveryInProgress,
  smartHubProduct,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const title = isDeliveryInProgress ? HC_IN_DELIVERY_TITLE : HC_IN_OPENREACH_APPT_TITLE;
  const description = isDeliveryInProgress ? HC_IN_DELIVERY_DESCRIPTION : HC_IN_OPENREACH_APPT_DESCRIPTION;
  const analyticsMilestoneType = isDeliveryInProgress ? ANALYTICS_TYPE_DELIVERY : ANALYTICS_TYPE_APPOINTMENT;
  const getOnlineLink =
    smartHubProduct === SMART_HUB_2_PRODUCT ? GET_ONLINE_SMART_HUB_2_URL : GET_ONLINE_SMART_HUB_3_URL;

  useEffect(() => {
    containerRef &&
      AppointmentAnalyticService.trackAppointmentEvent({
        ref: containerRef,
        value: `${analyticsMilestoneType}:Hybrid Connect`,
      });
  }, [containerRef]);

  return (
    <div ref={containerRef} className={styles.container}>
      <h4>{title}</h4>
      <div className={styles.hybridConnectImg} style={{ '--hybrid-connect-img': `url(${hybridConnectImg})` } as React.CSSProperties} />
      <p>{description}</p>
      <ExternalLink
        text={GET_ONLINE_LABEL}
        link={getOnlineLink}
        analytics={`${analyticsMilestoneType}:${GET_ONLINE_LABEL}`}
        iconClassName={styles.arrowIcon}
      />
    </div>
  );
};
